import { isNetworkRequestInFlight } from 'apollo-client/core/networkStatus'

import { useProjectBanner } from '../useProjectBanner'

import { useProjectData } from '../useProjectData'
import {
  useGetStorageItems,
  UseGetStorageItemsProps,
} from './useGetStorageItems'

export const useProject = ({
  workspaceId,
  projectId,
  search,
  filters,
}: UseGetStorageItemsProps) => {
  const storageItemsQuery = useGetStorageItems({
    projectId,
    workspaceId,
    search,
    filters,
  })
  const projectQuery = useProjectData(workspaceId, projectId)
  const project = projectQuery.currentProject

  useProjectBanner({ project, workspaceId })

  const loading =
    projectQuery.isInFlight ||
    isNetworkRequestInFlight(storageItemsQuery.networkStatus)

  const error = projectQuery.error || storageItemsQuery.error

  return {
    data: {
      project,
      storageItems: storageItemsQuery?.storageItems,
      breadcrumbs: projectQuery?.breadcrumbs,
    },
    loadMore: { storageItems: storageItemsQuery.fetchMore },
    loading,
    error,
    totalCount: storageItemsQuery.totalCounts,
  }
}
